import en from './en.json';
import es from './es.json';
import hi from './hi.json';
import zh from './zh.json';
import ar from './ar.json';
import fr from './fr.json';
import pt from './pt.json';
import de from './de.json';
import ja from './ja.json';
import ko from './ko.json';
import it from './it.json';
import tr from './tr.json';
import id from './id.json';
import pl from './pl.json';
import vi from './vi.json';
import th from './th.json';
import nl from './nl.json';
import ru from './ru.json';
import fil from './fil.json';
import uk from './uk.json';
import ro from './ro.json';
import sv from './sv.json';
import cs from './cs.json';
import el from './el.json';
import hu from './hu.json';

export const AI_PSYCHIC_COPY = { en, es, hi, zh, ar, fr, pt, de, ja, ko, it, tr, id, pl, vi, th, nl, ru, fil, uk, ro, sv, cs, el, hu };
